export const organisationDetails = (state) => state.organisationDetails;
export const products = (state) => state.organisationDetails.products;
export const transactions = (state) => state.transactions;
export const notificationCount = (state) => state.notificationCount;

export const TransactionPage = (state) => state.TransactionPageInfo.page;
export const TransactionPages = (state) => state.TransactionPageInfo.pages;
export const totalTransactions = (state) => state.TransactionPageInfo.total;
export const features = (state) => state.features.products;
export const tokens = (state) => state.tokens;
export const privateTokens = (state) => {
    const tokens = state.tokens;
    return tokens.filter((token) => {
        return token.type === "Private" && !token.entity;
    });
};
export const transactionFees = (state) => state.transactionFees;
export const lastRaiseStage = (state) => state.lastRaiseStage;
export const walletBalance = (state) => {
	const balances = state.walletBalance;
	const dataArray =
		balances &&
		Object.entries(balances).map(([value, balance]) => ({
			value,
			currency: `${value.substring(1)}`,
			balance,
		})).sort((a, b) => {
			if (a.currency === 'NGN' && b.currency !== 'NGN') {
			return -1;
			} else if (a.currency != 'NGN' && b.currency == 'NGN') {
			return 1;
			} else {
			return a.currency.localeCompare(b);
			}
		});
		
	return dataArray;
};
/**
 * Every bucket on each wallet, keyed the same way as walletBalance.
 *
 * The payload arrives keyed by gToken symbol (`gNGN`), so the leading "g" is dropped to get
 * the currency, exactly as the walletBalance getter above does.
 *
 * The four buckets are kept apart rather than summed into one "held" figure: they unwind by
 * different routes and on different timescales, so a company asking why its treasury is
 * locked needs to know which one has it. offer_hold is the money behind live bids.
 */
export const currencyWallets = (state) => {
	const wallets = state.currencyWallets;
	if (!wallets) return [];

	return Object.entries(wallets).map(([key, bucket]) => ({
		value: key,
		currency: key.substring(1),
		balance: Number(bucket?.balance || 0),
		escrow: Number(bucket?.escrow || 0),
		lien: Number(bucket?.lien || 0),
		offer_hold: Number(bucket?.offer_hold || 0),
		total: Number(bucket?.total || 0),
	}));
};

export const currency = (state) => state.currency;
export const minimumDeposit = (state) => state.minimumDeposit && Number(state.minimumDeposit[state.currency.toLowerCase()]);
export const virtualAccount = (state) => state.virtualAccount;
export const currencyRate = (state) => state.currencyRate
export const investmentCategories = (state) => state.investmentCategories
export const loans = (state) => state.loans
export const borrowers = (state) => state.borrowers
export const loanSummary = (state) => state.loanSummary
export const creditCurrency = (state) => state.creditCurrency
export const loanConfiguration = (state) => state.loanConfiguration
export const creditPage = (state) => state.creditPage;
export const creditPages = (state) => state.creditPages;
export const borrowerPage = (state) => state.borrowerPage;
export const borrowerPages = (state) => state.borrowerPages;
export const iamGroups = (state) => state.iamGroups
export const teamMembers = (state) => state.teamMembers
export const teamMember = (state) => state.teamMember;
